module.exports = ['javascript', 'angular', 'react', 'vue'];